export const mergeResponse = (input) => {
  return input?.reduce((acc, current) => {
    const existing = acc.find((item) => item.requestId === current.requestId);
    if (existing) {
      existing.servicesProvided = Array.isArray(existing.servicesProvided)
        ? [...new Set([...existing.servicesProvided, current.servicesProvided])]
        : [existing.servicesProvided, current.servicesProvided];

      existing.serviceCountries = Array.isArray(existing.serviceCountries)
        ? [...new Set([...existing.serviceCountries, current.serviceCountries])]
        : [existing.serviceCountries, current.serviceCountries];
    } else {
      acc.push({
        ...current,
        servicesProvided: [current.servicesProvided],
        serviceCountries: [current.serviceCountries],
      });
    }
    if (existing) {
      existing.serviceCountries =
        existing.serviceCountries.length === 1
          ? existing.serviceCountries[0]
          : existing.serviceCountries;
      existing.servicesProvided =
        existing.servicesProvided.length === 1
          ? existing.servicesProvided[0]
          : existing.servicesProvided;
    }
    return acc;
  }, []);
};
